import React from 'react';
import { 
	object, 
	func, 
	array,
	bool
} from 'prop-types';
import {InfoTooltip} from '../../molecules/Tooltip';
import QuizListHeader from '../../molecules/QuizListHeader/index';
import {QuizItemList} from '../../molecules/DragAndDropableList/index';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import Help from './Help';
import style from './style';

const Presenter = ({
	recipe,
	quizzes,
	onSort, 
	onPublish,
	onPlayQuiz,
	onDeleteRecipe,
	onCloseRecipe,
	onCheckQuiz,
	onDeleteQuiz,
	onRequestEditQuiz,
	onChangeRecipeName,
	onConfirmTimer,
	onCancelTimer,
	onJumpToSummaryPage,
	onToggleTimerInput,
	enableTimerInput,
	onAddTag,
	onRemoveTag,
	handleShuffle,
	onChangeRecipeDiscription,
	t
}) =>{
	const quizCount = (quizzes&&quizzes.length) || 0;
	const playable = quizzes&&quizzes.filter(q=>q.checked).length>0;
	const limitMin = recipe.timeLimit ? Math.floor(recipe.timeLimit / 60) : 0;
	const limitSec = recipe.timeLimit ? recipe.timeLimit % 60 : 0;
	return (
		<style.Wrapper>
			<style.HeaderWrapper>
				<style.TextInputComponent 
					value={recipe.name}
					onEnter={(value)=>{
						onChangeRecipeName(value,recipe);
					}}
					onBlur={(value)=>{
						onChangeRecipeName(value, recipe);
					}}
				/>
				<InfoTooltip text={t('create-quiz.ToSummaryPage')}>
					<style.IconButton  onClick={onJumpToSummaryPage(recipe)}>
						<style.StatsIcon />				
					</style.IconButton>
				</InfoTooltip>
				<InfoTooltip text={t('create-quiz.CloseRecipe')}>
					<style.IconButton onClick={onCloseRecipe} >
						<style.RemoveIcon />				
					</style.IconButton>
				</InfoTooltip>
			</style.HeaderWrapper>
			<style.DescriptionWrapper>
				<style.TextAreaComponent
					value={recipe.discription}
					onBlur={(value)=>onChangeRecipeDiscription(value, recipe)}
					placeholder={t('create-quiz.WhatIsDescription')} />
				<style.TimerWrapper>
					{enableTimerInput ? 
						(
							<span>
								<style.DurationPicker 
									onSubmit={onConfirmTimer(recipe)}
									onCancel={onCancelTimer}
									time={recipe.timeLimit}
								/>
							</span>
						) : 
						(
							<InfoTooltip text={t('create-quiz.SetTimeLimit')}>
								<style.IconButton onClick={onToggleTimerInput(true)}>
									<style.TimerIcon />
									<style.TimerLabel caption='[m]'>
										{limitMin}								
									</style.TimerLabel>
									<style.TimerLabel caption='[s]'>
										{limitSec}								
									</style.TimerLabel>
								</style.IconButton>
							</InfoTooltip>
						)
					}
				</style.TimerWrapper>
			</style.DescriptionWrapper>
			
			<QuizListHeader 
				quizCount={quizCount}
				onRemoveTag={(tag)=>{onRemoveTag(tag,recipe);}}
				onAddTag={(tag)=>{onAddTag(tag,recipe);}}
				handleShuffle={handleShuffle(recipe)}
				shuffle={Boolean(recipe.shuffle)}
				tags={recipe.tags || []}
			/>
			<style.QuizListWrapper>
				{ (quizzes && quizzes.length > 0) ? (
					<React.Fragment>
						<style.UL shuffle={recipe.shuffle}>
							<QuizItemList 
								indexed={!recipe.shuffle}
								values={quizzes}
								onSort={(newIndices)=>onSort(quizzes,recipe,newIndices)}
								onClick={(index)=>{onRequestEditQuiz(recipe.id,quizzes[index].id);}}
								onCheck={(chekced,index)=>{onCheckQuiz(recipe.id,quizzes[index].id,chekced);}}
								onDelete={(index)=>{onDeleteQuiz(quizzes[index].id);}}
							/>
						</style.UL>
					</React.Fragment>
				) : (
					<Help 
						onRequestEditQuiz={()=>{onRequestEditQuiz(recipe.id);}}
					/>
				) }
			</style.QuizListWrapper>
			
			<style.ButtonsWrapper>
				<style.ActionButtonsWrapper>
					<style.ContainedButton onClick={()=>{onRequestEditQuiz(recipe.id);}}>
						<style.PlusIcon />
						{t('create-quiz.CreateQuiz')}					
					</style.ContainedButton>
					<style.ContainedButton disabled={!playable} onClick={()=>{onPlayQuiz(recipe);}}>
						<style.PlayIcon />
						{t('create-quiz.PlayQuiz')}					
					</style.ContainedButton>
				</style.ActionButtonsWrapper>
				<style.Checkbox className='publish-checkbox' checked={recipe.published} onCheck={onPublish(recipe.id)}>
					{t('create-quiz.Publish')}
				</style.Checkbox>
				<style.ActionIconsWrapper>
					<style.DropDown pullRight dropup
						options = {[{
							name : <React.Fragment><style.TrashIcon/>{t('create-quiz.DeleteRecipe')}</React.Fragment>,
							callback : ()=>{onDeleteRecipe(recipe);}
						},
						]}
					/>
				</style.ActionIconsWrapper>
			</style.ButtonsWrapper>
		</style.Wrapper>
	);
};
Presenter.propTypes = {
	recipe:object,
	quizzes:array.isRequired,
	onPlayQuiz:func.isRequired,
	onPublish : func.isRequired,
	onCheckQuiz:func.isRequired,
	onDeleteQuiz:func.isRequired,
	onRequestEditQuiz:func.isRequired,
	onDeleteRecipe:func.isRequired,
	onCloseRecipe:func.isRequired,
	onChangeRecipeName:func.isRequired,
	onChangeRecipeDiscription:func.isRequired,
	onAddTag:func.isRequired,
	onRemoveTag:func.isRequired,
	handleShuffle:func.isRequired,
	onSort:func.isRequired,
	onToggleTimerInput:func.isRequired,
	onConfirmTimer:func.isRequired,
	onCancelTimer:func.isRequired,
	enableTimerInput:bool.isRequired,
	onJumpToSummaryPage:func.isRequired,
	t:func.isRequired
};

export default withNamespaces()(Presenter);